import React from 'react';
import PropTypes from 'prop-types';

import SVG from '../../reset/index';

const ResetButtonComponent = ({width, height, className}) => {
  return <SVG wdith={width} height={height} className={className} />;
};

ResetButtonComponent.propTypes = {
  /** The width of the reset button. */
  width: PropTypes.string,

  /** The height of the reset button. */
  height: PropTypes.string,

  /** The class name of the reset button. */
  className: PropTypes.string,
};

ResetButtonComponent.defaultProps = {
  width: '12px',
  height: '12px',
  className: 'mapbox-reset-button',
};

export default ResetButtonComponent;
